import { ManualProcessStatusType } from '@golden/gdk-admin'

const manualProcessStatusColor: { [key in ManualProcessStatusType]: string } = {
  [ManualProcessStatusType.PENDING]: '#808080',
  [ManualProcessStatusType.PROCESSING]: '#72d476',
  [ManualProcessStatusType.FAILED]: '#ff5f5f'
}

export default manualProcessStatusColor
